import api from "./client";

export const addRooms = async (hotelId, roomData) => {
  try {
    if (!hotelId) {
      throw new Error("Hotel ID is required");
    }

    if (!roomData || !roomData.type || roomData.Total_rooms === undefined) {
      throw new Error("Room type and Total_rooms are required");
    }

    const response = await api.post(`/addRooms/${hotelId}`, roomData);
    return response.data;
  } catch (error) {
    console.error("Error adding rooms:", error);
    throw error;
  }
};

export const updateRoom = async (hotelId, roomType, roomData) => {
  try {
    if (!hotelId) {
      throw new Error("Hotel ID is required");
    }

    if (!roomType) {
      throw new Error("Room type is required");
    }

    if (!roomData) {
      throw new Error("Room data is required");
    }

    const response = await api.put(`/updateRoom/${hotelId}/${roomType}`, roomData);
    return response.data;
  } catch (error) {
    console.error("Error updating room:", error);
    throw error;
  }
};

export const deleteRoom = async (hotelId, roomType, airlineId) => {
  try {
    if (!hotelId) {
      throw new Error("Hotel ID is required");
    }

    if (!roomType) {
      throw new Error("Room type is required");
    }

    const query = airlineId ? `?airline_id=${airlineId}` : "";
    const response = await api.delete(`/deleteRoom/${hotelId}/${roomType}${query}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting room:", error);
    throw error;
  }
};

export const toggleRoomStatus = async (hotelId, roomType, status, airlineId) => {
  try {
    if (!hotelId) {
      throw new Error("Hotel ID is required");
    }

    if (!roomType) {
      throw new Error("Room type is required");
    }

    const response = await api.put(`/updateRoom/${hotelId}/${roomType}`, { status, airline_id: airlineId });
    return response.data;
  } catch (error) {
    console.error("Error toggling room status:", error);
    throw error;
  }
};

export const setQRPassword = async (hotelId, roomType, password, airlineId) => {
  try {
    const response = await api.post('/qr/set-password', { hotel_id: hotelId, room_type: roomType, password, airline_id: airlineId });
    return response.data;
  } catch (error) {
    console.error("Error setting QR password:", error);
    throw error;
  }
};

export const resendAllocationEmail = async (hotelId, roomType, airlineId) => {
  try {
    const response = await api.post('/qr/resend-email', { hotel_id: hotelId, room_type: roomType, airline_id: airlineId });
    return response.data;
  } catch (error) {
    console.error("Error resending allocation email:", error);
    throw error;
  }
};

